import { render } from "./Ajustes.vue?vue&type=template&id=57a9ba3c"
import script from "./Ajustes.vue?vue&type=script&lang=js"
export * from "./Ajustes.vue?vue&type=script&lang=js"

import "./Ajustes.vue?vue&type=style&index=0&id=57a9ba3c&lang=css"

import exportComponent from "D:\\Trabajo\\Raxar\\backoffice-base-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__